import React from 'react'
import ExcelJs from 'exceljs'

const ExportExcel = (props) => {
  function onClick() {
    const workbook = new ExcelJs.Workbook()
    props.sheetDatas.forEach((sheetData) => {
      const sheet = workbook.addWorksheet(sheetData.sheetName)
      sheet.addTable({
        name: sheetData.sheetName,
        ref: `A1`, // 從A1開始
        headerRow: true,
        columns: sheetData.thead.map((s) => {
          return {
            name: s,
          }
        }),

        rows: sheetData.tbody,
      })
      if (sheetData.columnWidths) {
        sheetData.columnWidths.forEach((column) => {
          sheet.getColumn(column.number).width = column.width
        })
      }
      // sheet.getRow(1).fill = {
      //   type: 'pattern',
      //   pattern: 'solid',
      //   bgColor: { argb: 'FFFFFFFF' },
      // }
      // sheet.getRow(1).font = {
      //   bold: true,
      //   color: { argb: '000000' },
      // }
    })

    // 表格裡面的資料都填寫完成之後，訂出下載的callback function
    // 異步的等待他處理完之後，創建url與連結，觸發下載
    workbook.xlsx.writeBuffer().then((content) => {
      const link = document.createElement('a')
      const blob = new Blob([content], {
        type: 'application/vnd.ms-excel;charset=utf-8;',
      })
      link.download = `${props.fileName}.xlsx`
      link.href = URL.createObjectURL(blob)
      link.click()
    })
  }

  return (
    <>
      <i onClick={onClick} className="fa-solid fa-circle-down"></i>
    </>
  )
}

export default ExportExcel
